import assetPath from '/app/xinglets/business-solutions/page/src/assets/premium-seats.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')